import { api } from '../../../api/client';

export const certificateTypesApi = {
  search: (dataSearch) => api.post('/build/type-certificates/search',dataSearch),

  create: (data) => api.post('/build/type-certificates', data),

  update: (id, data) => api.put(`/build/type-certificates/${id}`, data),

  remove: (id) => api.delete(`/build/type-certificates/${id}`),
  //otros metodos
  getNames:()=>api.get('/build/type-certificates/getNames'),
    getNamesInactives:()=>api.get('/build/type-certificates/getNamesInactives')

};
